// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"3d0bdfbd","651":"3313ed50","983":"4c6c0253"}[chunkId] + ".chunk.js";
};